var React = require('react');

function LocatorPinIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.65482 10.5236V15.7263L5.38999 16.8227C5.54858 17.0591 5.89814 17.0591 6.05672 16.8227L6.79156 15.7263V10.5236C6.44467 10.5874 6.08844 10.6252 5.72319 10.6252C5.35794 10.6252 5.00171 10.5874 4.65482 10.5236ZM5.72319 0C3.06796 0 0.915527 2.14065 0.915527 4.78134C0.915527 7.42204 3.06796 9.56269 5.72319 9.56269C8.37842 9.56269 10.5309 7.42204 10.5309 4.78134C10.5309 2.14065 8.37842 0 5.72319 0ZM5.72319 2.52349C4.4712 2.52349 3.45291 3.5362 3.45291 4.78134C3.45291 5.00115 3.27329 5.17979 3.05227 5.17979C2.83125 5.17979 2.65163 5.00115 2.65163 4.78134C2.65163 3.09692 4.02983 1.7266 5.72319 1.7266C5.94421 1.7266 6.12383 1.90523 6.12383 2.12504C6.12383 2.34485 5.94421 2.52349 5.72319 2.52349Z","fill":"#FFC72A"}));
}

LocatorPinIcon.defaultProps = {"width":"11","height":"17","viewBox":"0 0 11 17","fill":"none"};

module.exports = LocatorPinIcon;

LocatorPinIcon.default = LocatorPinIcon;
